import React from 'react';
import { Controller, Control } from 'react-hook-form';

import { VbzDropdown } from '@smiles/voebiz-ui-kit';

type PropsT = {
  actions: { name: string; description: string }[];
  control: Control;
  name: string;
  error: boolean;
  textLabel: string;
  rules?: Record<string, unknown>;
  placeholder: string;
  errorMessage: string;
  disable?: boolean;
};

export default function ControlledDropdown(props: PropsT) {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      render={({ value, onChange, name }) => (
        <VbzDropdown
          actions={props.actions}
          id={name}
          placeholder={props.placeholder}
          errorMessage={props.errorMessage}
          value={value}
          onChange={onChange}
          onClick={onChange}
          textLabel={props.textLabel}
          forceError={props.error}
          disabled={props.disable}
          textMobile=""
        />
      )}
    />
  );
}

ControlledDropdown.defaultProps = {
  disable: false,
  rules: { required: false },
};
